import styled, { css } from 'styled-components'
import ExternalLink from '../../../common/external-link'
import CloseIcon from '../../../../assets/icons/close-bold.svg'
import { tabletBreakpoint } from 'react-components'
import WishlistIcon from '../../../../assets/icons/heart-outline.svg'

export const Container = styled.div`
    display: flex;
    gap: 0.5rem;
    overflow: auto;
    border-left: 1px dotted #d5d5d5;
    padding-left: 0.75rem;
    align-items: center;
    flex: 1;

    /* Custom scrollbar styling */
    scrollbar-width: thin; /* Firefox */
    &::-webkit-scrollbar {
        height: 1px;
        width: 2px;
    }

    &::-webkit-scrollbar-thumb {
        background-color: #d5d5d5;
        border-radius: 0.5rem;
    }
`

export const HeaderRow = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    width: 100%;
    position: relative;
`

export const PillWrapper = styled.div(
    ({ theme }) => css`
        display: flex;
        flex: 1;
        gap: 0.5rem;

        min-width: 0;
        overflow-x: auto;
        scrollbar-width: none;

        padding-top: ${theme.spacing.small};
        margin-top: -${theme.spacing.small};

        padding-right: ${theme.spacing.xxxLarge};

        &::-webkit-scrollbar {
            display: none;
        }

        > * {
            flex-shrink: 0;
        }
    `,
)

export const MobilePillButton = styled.button<{ isActive?: boolean }>`
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 0.25rem 0.5rem;
    background: ${({ isActive, theme }) => (isActive ? theme.colors?.tfwGrey || '#f6f6f6' : 'white')};
    border: ${({ isActive }) => (isActive ? `2px solid #282828` : `1px solid #ccc'}`)};
    border-radius: 8rem;
    font-size: 0.875rem;
    line-height: 1.375rem;
    white-space: nowrap;
    cursor: pointer;
    color: #282828;
    flex-shrink: 0;
`

export const MobileWishlistButton = styled(ExternalLink)(
    ({ theme }) => css`
        display: flex;
        height: 3.5rem;
        width: 3.5rem;
        align-items: center;
        justify-content: center;
        position: absolute;
        right: -1rem;
        background: ${theme.colors.white};
        box-shadow: -8px 0px 20px -8px rgba(0, 0, 0, 0.12);
        border-radius: 2rem 0 0 2rem;
        z-index: 2;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            display: none;
        }
    `,
)

export const WishlistBadge = styled.div`
    background-color: ${({ theme }) => theme.colors.tfwRed};
    color: white;
    width: 1rem;
    height: 1rem;
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: -0.2rem;
    right: 0.6rem;
    font-weight: 600;
    font-size: 0.75rem;
    line-height: 1rem;
    border-radius: 50%;
`

export const WishlistIconContainer = styled.div`
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 1.5rem;
    height: 1.5rem;
`

export const CloseIconStyled = styled(CloseIcon)`
    width: 1rem;
    height: 1rem;
`
export const WishlistIconStyled = styled(WishlistIcon)`
    width: 1.5rem;
    height: 1.5rem;
`

export const ClearAllLink = styled.a(
    ({ theme }) => `
        font-family: ${theme.typography.font.family.latoVerdana};
        color: #006ad4;
        font-weight: 400;
        font-size: ${theme.typography.font.size.small};
        line-height: 1.375rem;
        text-decoration: none;
        cursor: pointer;
        margin-left: ${theme.spacing.xSmall};
        white-space: nowrap;
        flex-shrink: 0;

        &:hover {
            text-decoration: underline;
        }
    `,
)
